/* eslint-disable */
export default {
  unknown: 'Unbekannt',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
